/**
 * Callisto logo — renders the Callisto wordmark image.
 */
export function CallistoLogo({ size = "md", variant = "light", className = "" }) {
  const heights = {
    sm: "h-7",
    md: "h-9",
    lg: "h-12",
  };
  const height = heights[size] || heights.md;
  return (
    <img
      src="/logo-full.png"
      alt="Callisto"
      className={`${height} w-auto object-contain ${className}`}
      data-testid="callisto-logo"
    />
  );
}
